<template>
  <div class="wrapper">
    <div class="main">
      <div class="list">
        <div class="item" v-for="(item,index) in list" :key="index">
          <div class="img-wrap">
            <img v-lazy="item.goods.image_url" :alt="item.goods_name" :key="item.goods.image_url">
          </div>
          <div class="title">{{item.goods_name}}</div>
          <div class="price">{{item.goods.price}}元</div>
          <div class="actions">
            <a href="javascript:;" class="del" @click="delCollete(item.goods_id,index)">删除</a>
            <a href="javascript:;" class="detail" @click="lookDetail(item.goods_id)">查看详情</a>
          </div>
        </div>
      </div>
      <template v-if="list.length>0">
        <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
      </template>
      <template v-else>您还没有收藏过任何商品</template>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
  name: "Favourite",
  components: { Pagination },
  props: {},
  data() {
    return {
      list: [],
      totalPage: 0,
      page: 1,
      limit: 10
    };
  },
  watch: {},
  computed: {},
  methods: {
    getFavList() {
      let data = {
        page: this.page,
        limit: this.limit
      };
      this.$api.goodsCollectionList(data).then(res => {
        if (res.status) {
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          );
          this.list = res.data.list;
        }
      });
    },
    delCollete(id, index) {
      let data = {
        goods_id: id
      };
      this.$api.goodsCollection(data).then(res => {
        if (res.status) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success"
          });
          this.$nextTick(() => {
            this.list.splice(index, 1);
          });
        }
      });
    },
    lookDetail(id) {
      this.$router.push({ name: "detail", params: { goodsId: id } });
    },
    //分页加载
    handOrderMore(val) {
      this.page = val;
      this.getFavList();
    }
  },
  created() {},
  mounted() {
    this.getFavList();
  }
};
</script>
<style lang="scss" scoped>
@import "./Favourite.scss";
</style>